module.exports = __webpack_public_path__ + "img/pl.25f16e20.png";